var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnership(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.05 88.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#505050;}.cls-3{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.39,52.86A16.4,16.4,0,0,0,97,44.28,16.46,16.46,0,0,0,88.7,61.92,16.43,16.43,0,0,0,96.39,52.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.27,57.29A30,30,0,0,1,96.68,73a16.49,16.49,0,0,0,8.17,2.17h0a16.33,16.33,0,0,0,6.59-1.38l49.15-21.59a16.45,16.45,0,1,0-13.23-30.12L109.53,38.68A29.84,29.84,0,0,1,109.27,57.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.83,46.69l-3.11-1.07a16.29,16.29,0,0,1-8.27-6.37,16.3,16.3,0,0,1-7.64,6.14L5.13,46.83a29.91,29.91,0,0,0,11.32,10A29.7,29.7,0,0,0,27.83,46.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.51,24.72a16.07,16.07,0,0,1,1.93-3.84A16.47,16.47,0,0,0,4.85,13.75a29.69,29.69,0,0,0-3.22,6.54,30.07,30.07,0,0,0,3.5,26.54l3.68-1.44a16.3,16.3,0,0,0,7.64-6.14,17.55,17.55,0,0,1-1.16-2A16.32,16.32,0,0,1,14.51,24.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,13.76a16.06,16.06,0,0,1,3.86,0,16.38,16.38,0,0,1,3.51.8L86.18,32A16.5,16.5,0,0,1,89,33.21a30.38,30.38,0,0,1,3.78-2l9.92-4.36a29.93,29.93,0,0,0-12-7.75L39.84,1.63A31,31,0,0,0,33.41.18,29.9,29.9,0,0,0,16.48,3.31,30.07,30.07,0,0,1,28,13.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.07,62.93,27.83,46.69A29.7,29.7,0,0,1,16.45,56.87a31.16,31.16,0,0,0,3.84,1.63L71.06,76a30.37,30.37,0,0,0,6.43,1.45,28.61,28.61,0,0,0,3.92.15,29.78,29.78,0,0,1-6.34-14.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97,44.28A16.33,16.33,0,0,1,88.7,61.92a16.57,16.57,0,0,0,1.06,3.41A16.39,16.39,0,0,0,96.68,73a29.8,29.8,0,0,0,12.85-34.31l-11.32,5C97.77,43.84,97.36,44.06,97,44.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.85,13.75a16.47,16.47,0,0,1,11.59,7.13A16.61,16.61,0,0,1,28,13.76,30.07,30.07,0,0,0,16.48,3.31,30.41,30.41,0,0,0,4.85,13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89,33.21a16.31,16.31,0,0,1,6.66,7.09,17,17,0,0,1,1.34,4c.41-.22.82-.44,1.26-.63l11.32-5a29.45,29.45,0,0,0-6.88-11.85l-9.92,4.36A30.38,30.38,0,0,0,89,33.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.5,25A30,30,0,0,0,141.89,9.6L102.65,26.83a29.45,29.45,0,0,1,6.88,11.85l37.83-16.61a16.45,16.45,0,1,1,13.23,30.12L111.44,73.78a16.33,16.33,0,0,1-6.59,1.38h0A16.49,16.49,0,0,1,96.68,73a30.15,30.15,0,0,1-15.27,4.56,30,30,0,0,0,35.5,8.69l49.15-21.58A30.09,30.09,0,0,0,181.5,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97,44.28a17,17,0,0,0-1.34-4A16.31,16.31,0,0,0,89,33.21,30,30,0,0,0,75.07,62.93l.42.14A16.17,16.17,0,0,0,88.7,61.92,16.46,16.46,0,0,1,97,44.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.76,65.33a16.57,16.57,0,0,1-1.06-3.41,16.17,16.17,0,0,1-13.21,1.15l-.42-.14a29.78,29.78,0,0,0,6.34,14.62A30.15,30.15,0,0,0,96.68,73,16.39,16.39,0,0,1,89.76,65.33Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnership);
export default __webpack_public_path__ + "static/media/partnership.8f5090ebd7449623981a9b5415ac7783.svg";
export { ForwardRef as ReactComponent };